/* eslint-disable no-unexpected-multiline */
import types from '../types'
import Helpers from '../Helpers.js'
import {changeQuestion} from './changeQuestion2'
// import prefilledAnswers from '../prefilled_answers'

export const fetchSectionResponse = () => (dispatch, getState) => {
  const {
    currentPqId,
    currentPqIdIndex,
    currentUfqIdIndex,
    prompt1Response,
    selectedSectionIndex,
    selectedSubSectionIndex,
    selectedSectionName,
    selectedSubSectionName,
    documents,
  } = getState().userReducer
  function onFail(err) {
    console.log('Error getting minor-element response', err)
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        userMessage: 'Error: please try again.',
        notificationType: 3,
        notificationIcon: 'warning',
        isLoading: false,
      },
    })
  }
  dispatch({
    type: types.STORE_PAYLOAD,
    payload: {
      isLoading: true,
    },
  })
  const data = {
    major_section: selectedSectionName,
    data: prompt1Response,
    // data: prefilledAnswers,
  }

  // console.log('data sending', data)
  Helpers.fetchPostJson2(
      process.env.REACT_APP_API_URL + '/download_major_section',
      data,
      {
        orgId: process.env.REACT_APP_ORG_ID,
        authKey: process.env.REACT_APP_AUTH_KEY,
      },
  )
      .then((res) => {
        if (res.ok) {
          res.blob().then((blob) => {
            setTimeout(() => {
              const url = window.URL.createObjectURL(blob)
              const a = document.createElement('a')
              a.href = url
              a.download = `${selectedSectionName}.docx`
              a.click()
              dispatch({
                type: types.STORE_PAYLOAD,
                payload: {
                  typeFormStep: 'typeform',
                  step: 'section-select',
                  isSubSectionReadyForReview: false,
                  isReview: false,
                  isLoading: false,
                  documents: {
                    ...documents,
                    [selectedSectionName]: url,
                    time: Date.now(),
                  },
                },
              })
              const changeQuestionProps = {
                newSubSectionIndex: selectedSubSectionIndex + 1,
                newPqIdIndex: currentPqIdIndex + 1,
                newUfqIdIndex: currentUfqIdIndex + 1,
                currentPqId,
                currentPqIdIndex,
                currentUfqIdIndex,
                prompt1Response,
                selectedSectionIndex,
                selectedSubSectionIndex,
                selectedSectionName,
                selectedSubSectionName,
                // even though it is review, currently skip is prevented
                isReview: false,
                isSubSectionReadyForReview: false,
              }
              dispatch(changeQuestion(changeQuestionProps))
            }, [2000])
          })
        } else {
          onFail(res)
        }
      })
      .catch(onFail)
      // .finally(() => {
      //   dispatch({
      //     type: types.STORE_PAYLOAD,
      //     payload: {
      //       isLoading: false,
      //     },
      //   })
      // })
}
